import { render, staticRenderFns, recyclableRender, components } from "./seckillProduct.vue?vue&type=template&id=eb620bee&"
var renderjs
import script from "./seckillProduct.vue?vue&type=script&lang=js&"
export * from "./seckillProduct.vue?vue&type=script&lang=js&"
import style0 from "./seckillProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/seckillProduct/seckillProduct.vue"
export default component.exports